class WeeklyDealsCountdown {
  constructor(section) {
    this.section = section;

    const timer = section.querySelector(".section-weekly-deals-timer");
    if (!timer) return;

    this.days = timer.querySelector(".days");
    this.hours = timer.querySelector(".hours");
    this.minutes = timer.querySelector(".minutes");
    this.seconds = timer.querySelector(".seconds");

    const endDate = section.dataset.endDate;

    if (!endDate) return;

    this.endTime = new Date(endDate).getTime();

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {

    const now = new Date().getTime();
    const distance = this.endTime - now;

    if (distance <= 0) {

      clearInterval(this.interval);

      this.days.textContent = "00";
      this.hours.textContent = "00";
      this.minutes.textContent = "00";

      if (this.seconds) {
        this.seconds.textContent = "00";
      }

      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));

    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) /
      (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (distance % (1000 * 60 * 60)) /
      (1000 * 60)
    );

    const seconds = Math.floor(
      (distance % (1000 * 60)) / 1000
    );

    this.days.textContent = String(days).padStart(2, "0");
    this.hours.textContent = String(hours).padStart(2, "0");
    this.minutes.textContent = String(minutes).padStart(2, "0");

    if (this.seconds) {
      this.seconds.textContent = String(seconds).padStart(2, "0");
    }

  }
}

document.querySelectorAll(".section-weekly-deals").forEach(section => {
  new WeeklyDealsCountdown(section);
});